import { Button } from "primereact/button";

export function FormInputSearch({ register, errors, id, name,step,
  labelText, type, rules, disabled = false,
  placeholder, labelClass = "", enterClick,
  onChange, maxLength, onInput, style = {},
  wrapperClass, wrapperStyle = {}, btnSerch,
  disabledBtn=false,readOnly=false,
  icon="search",value,...reset }) {
  //   console.log('id',id);
  // console.log('errors',errors);
  // console.log('errors[id]',errors[id]);

  let errorObj = undefined;
  if (id.split('.').length > 1 && Object.keys(errors).length > 0) {
    let tarErrors = errors;
    let errorObjCheckIdx = 0;
    const idArr = id.split('.');
    // console.log('複雜欄位檢核', idArr)
    idArr.forEach((res, idx) => {
      if (tarErrors[res]) {
        errorObjCheckIdx = idx
        tarErrors = tarErrors[res];
      }
    })

    if (errorObjCheckIdx === idArr.length - 1) {
      errorObj = tarErrors
    } else errorObj = undefined;
  }

  return (
    <div className={`custom-input has-btn ${wrapperClass}`} style={wrapperStyle}>
      {
        labelText ? (<label htmlFor={id} className={`form-label` + ` ${labelClass}`}>{labelText}</label>)
          : <></>
      }
        <input
          step={step}
          maxLength={maxLength}
          onChange={onChange}
          onInput={onInput}
          onKeyDown={enterClick}
          placeholder={placeholder}
          disabled={disabled}
          id={id}
          name={name}
          type={type}
          readOnly={readOnly}
          {...register(id, rules)}
          className={`p-inputtext p-component ${(errors[id] ? errors[id] : ((id.split('.').length > 1 && errorObj) ? errorObj : false)) && ' p-invalid'} `}
          style={style}
          value={value}
          {...reset}
        />
      <div className="button-setting" style={{
            bottom: errors[id] || errorObj ? '18px' : '0px', // 根據需求替換初始值
          }}>
        <Button disabled={disabledBtn} 
          text 
          type="button" 
          onClick={btnSerch} 
          icon={`pi pi-${icon}`}>
        </Button>
      </div>
      


      {(errors[id] ? errors[id] : errorObj) && (
        <small className='p-error'>{errors[id] ? (errors?.[id]?.message) : errorObj.message}</small>
      )}

    </div>
  )
}
